<template>
  <div class="bg-white shadow-md rounded-xl p-4 m-4">
    <MonkeyLoader v-if="isLoading" />
    <h2 class="text-xl font-semibold mb-4 text-gray-800">
      SPK Subcon Authorization
    </h2>

    <form @submit.prevent="saveForm">
      <div class="mb-4 flex gap-4">
        <div class="w-2/3">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="spkNumber">
            SPK #:
          </label>
          <select
            class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="spkNumber" v-model="formData.spkNumber" required>
            <option value="">-- Pilih SPK # --</option>
            <option v-for="spk in spkOptions" :key="spk.id" :value="spk.id">
              {{ spk.spkNum }}
            </option>
          </select>
        </div>
        <div class="w-1/3">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="spkDate">
            SPK Date:
          </label>
          <input
            class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="date" id="spkDate" v-model="formData.spkDate" />
        </div>
      </div>

      <div class="data-grid-container mt-6">
        <h3 class="text-lg font-semibold mb-2 text-gray-800">Detail Pekerjaan</h3>
        <div class="overflow-x-auto">
          <table class="min-w-full table-auto">
            <thead>
              <tr>
                <th class="px-4 py-2 border-b text-left">
                  <input type="checkbox" v-model="selectAll" @change="toggleSelectAll"
                    class="form-checkbox h-4 w-4 text-blue-500 focus:ring-blue-500 border-gray-300 rounded">
                  Chk All
                </th>
                <th class="px-4 py-2 border-b text-left">No</th>
                <th class="px-4 py-2 border-b text-left">PO Number</th>
                <th class="px-4 py-2 border-b text-left">Sitename</th>
                <th class="px-4 py-2 border-b text-left">Area</th>
                <th class="px-4 py-2 border-b text-left">Project Name</th>
                <th class="px-4 py-2 border-b text-left">Price</th>
                <th class="px-4 py-2 border-b text-left">Start Date</th>
                <th class="px-4 py-2 border-b text-left">End Date</th>
                <th class="px-4 py-2 border-b text-left" hidden>SPK Detail ID</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(detail, index) in detailPekerjaan" :key="index">
                <td class="px-4 py-2 border-b">
                  <input type="checkbox" v-model="detail.checked"
                    class="form-checkbox h-4 w-4 text-blue-500 focus:ring-blue-500 border-gray-300 rounded">
                </td>
                <td class="px-4 py-2 border-b">{{ index + 1 }}</td>
                <td class="px-4 py-2 border-b">{{ detail.poNumber }}</td>
                <td class="px-4 py-2 border-b">{{ detail.sitename }}</td>
                <td class="px-4 py-2 border-b">{{ detail.area }}</td>
                <td class="px-4 py-2 border-b">{{ detail.projectName }}</td>
                <td class="px-4 py-2 border-b">{{ detail.priceFormatted }}</td>
                <td class="px-4 py-2 border-b">{{ detail.startDate }}</td>
                <td class="px-4 py-2 border-b">{{ detail.endDate }}</td>
                <td class="px-4 py-2 border-b" hidden>{{ detail.spkDetailId }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="form-section mt-6">
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="reason">
            Reason:
          </label>
          <select
            class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="reason" v-model="formData.reason" required>
            <option value="">-- Pilih Reason --</option>
            <option value="1">Approve SPK > 1 Kali</option>
            <option value="2">Update Price</option>
            <option value="3">Update Site</option>
            <option value="4">Update Subcon</option>
          </select>
        </div>

        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="remark">
            Remark:
          </label>
          <textarea
            class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="remark" rows="3" v-model="formData.remark" required></textarea>
        </div>
      </div>

      <div class="form-actions mt-6 flex justify-center gap-2">
        <button type="submit"
          class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline w-1/6">
          Approve
        </button>
        <button type="button" @click="exitForm"
          class="bg-gray-300 hover:bg-gray-400 text-gray-700 font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline w-1/6">
          Exit
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import MonkeyLoader from '../Layout/MonkeyLoader.vue';

const API_ENDPOINTS = {
  spkFiles: `${window.location.origin}/api/spksubconfiles`,
  spkFileById: (spkId) => `${window.location.origin}/api/spksubconfiles/${spkId}`,
  authorizeSpk: `${window.location.origin}/api/spksubconauth`,
};

export default {
  components: { MonkeyLoader },
  data() {
    return {
      formData: {
        spkNumber: '',
        spkDate: this.getCurrentDate(),
        reason: '',
        remark: '',
      },
      spkOptions: [],
      detailPekerjaan: [],
      selectAll: false,
    };
  },
  methods: {
    getCurrentDate() {
      const today = new Date();
      return today.toISOString().split('T')[0];
    },
    async loadSpkOptions() {
      try {
        const response = await axios.get(API_ENDPOINTS.spkFiles, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        this.spkOptions = response.data.map(spk => ({
          id: spk.Id,
          spkNum: spk.SpkNum,
        }));
      } catch (error) {
        console.error('Error fetching SPK options:', error);
        this.spkOptions = [];
      }
    },

    async getSpkDetails(spkId) {
      this.detailPekerjaan = [];
      try {
        const response = await axios.get(API_ENDPOINTS.spkFileById(spkId), {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });

        const data = response.data;
        this.formData.spkDate = data.SpkDate?.substring(0, 10);

        const spkDetails = data.TblSpksubconDetails;
        if (!spkDetails || spkDetails.length === 0) {
          return;
        }

        const poIds = [...new Set(spkDetails.map(d => d.PoId).filter(id => id))];
        const projectInfoMap = new Map();
        const batchSize = 5;

        for (let i = 0; i < poIds.length; i += batchSize) {
          const idBatch = poIds.slice(i, i + batchSize);
          const promises = idBatch.map(id =>
            axios.get(`https://meeting-backend.iotech.my.id/projects-bypo/${id}`, {
              headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            }).then(res => {
              if (res.data && res.data.length > 0) {
                projectInfoMap.set(id, res.data[0]);
              }
            }).catch(err => {
              console.warn(`Gagal mengambil info project untuk PoId ${id}:`, err);
            })
          );
          await Promise.all(promises);
        }

        this.detailPekerjaan = spkDetails.map(detail => {
          const project = projectInfoMap.get(detail.PoId) || {};
          return {
            id: detail.Id,
            poNumber: detail.PoNum,
            sitename: detail.Sitename,
            area: project.city?.name || '', // PERBAIKAN DI SINI
            projectName: project.name || '', // PERBAIKAN DI SINI
            priceFormatted: new Intl.NumberFormat('id-ID', {
              style: 'currency', currency: 'IDR', minimumFractionDigits: 0
            }).format(detail.Price || 0),
            startDate: this.formatDate(detail.StartDate),
            endDate: this.formatDate(detail.EndDate),
            spkDetailId: detail.Id,
            checked: false,
          };
        });
      } catch (error) {
        console.error('Error fetching SPK Details:', error);
        Swal.fire({ icon: 'error', title: 'Gagal Memuat Detail', text: 'Tidak dapat mengambil detail SPK.' });
      } finally {
        this.selectAll = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('id-ID', {
        day: '2-digit', month: 'short', year: 'numeric'
      }).format(date);
    },

    toggleSelectAll() {
      this.detailPekerjaan.forEach(detail => {
        detail.checked = this.selectAll;
      });
    },

    async saveForm() {
      const selectedDetailIds = this.detailPekerjaan
        .filter(detail => detail.checked)
        .map(detail => detail.spkDetailId);

      if (selectedDetailIds.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Perhatian', text: 'Harap pilih setidaknya satu Detail Pekerjaan untuk diotorisasi.' });
        return;
      }

      if (!this.formData.reason || !this.formData.remark.trim()) {
        Swal.fire({ icon: 'warning', title: 'Data Tidak Lengkap', text: 'Alasan dan Keterangan harus diisi.' });
        return;
      }

      const authData = {
        spkSubconFileId: this.formData.spkNumber,
        authReason: this.formData.reason,
        authRemark: this.formData.remark,
        authorizedDetailIds: selectedDetailIds,
      };

      try {
        await axios.post(API_ENDPOINTS.authorizeSpk, authData, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        Swal.fire({ icon: 'success', title: 'Berhasil', text: 'Otorisasi SPK berhasil disimpan!' });
        this.resetForm();
      } catch (error) {
        console.error('Error saat menyimpan otorisasi SPK:', error);
        const errorMsg = error.response?.data?.message || 'Terjadi kesalahan pada server.';
        Swal.fire({ icon: 'error', title: 'Gagal Menyimpan', text: errorMsg });
      }
    },

    // PERBAIKAN DI SINI
    resetForm() {
      this.formData.spkNumber = '';
      this.formData.spkDate = this.getCurrentDate();
      this.formData.reason = '';
      this.formData.remark = '';
      this.detailPekerjaan = [];
      this.selectAll = false;
      this.loadSpkOptions();
    },
    exitForm() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.loadSpkOptions();
  },
  watch: {
    'formData.spkNumber'(newSpkNumber) {
      if (newSpkNumber) {
        this.getSpkDetails(newSpkNumber);
      } else {
        this.detailPekerjaan = [];
        this.selectAll = false;
      }
    },
    detailPekerjaan: {
      handler(newDetails) {
        if (newDetails.length === 0) {
          this.selectAll = false;
          return;
        }
        this.selectAll = newDetails.every(detail => detail.checked);
      },
      deep: true,
    }
  },
};
</script>



<style scoped>
.input-border {
  border-bottom: 2px solid #ccc;
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-top: none;
}

.input-border:focus {
  border-bottom-color: #007bff;
  box-shadow: none;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.form-group textarea {
  resize: vertical;
}

.form-actions {
  margin-top: 20px;
}

.form-actions button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.form-actions button:first-child {
  background-color: #28a745;
  color: white;
  margin-right: 10px;
}

.form-actions button:last-child {
  background-color: #dc3545;
  color: white;
}

.data-grid-container {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 4px;
}

.data-grid-container h3 {
  margin-top: 0;
  margin-bottom: 10px;
}

.data-grid-container table {
  width: 100%;
  border-collapse: collapse;
}

.data-grid-container th,
.data-grid-container td {
  border: 1px solid #eee;
  padding: 8px;
  text-align: left;
}

.data-grid-container th {
  background-color: #f0f0f0;
  font-weight: bold;
}

.gspe-info {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 4px;
}

.gspe-info h3 {
  margin-top: 0;
  margin-bottom: 10px;
}

.gspe-info .form-actions {
  margin-top: 15px;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}
</style>